import { render } from "./AppPagination.vue?vue&type=template&id=757063ca&scoped=true"
import script from "./AppPagination.vue?vue&type=script&lang=js"
export * from "./AppPagination.vue?vue&type=script&lang=js"

import "./AppPagination.vue?vue&type=style&index=0&id=757063ca&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757063ca"]])

export default __exports__